import React from 'react'

import { Box, Container, Grid, Typography } from '@mui/material';
import Holder from '../../Components/Holder';
import MotionAppear from '../../Components/MotionAppear';
import { titleStyle } from './constants';
import { EditableTypography } from '../../Components/EditableTypography';
import Centered from '../../Components/Centered';
import { useFirestore } from '../../Firebase/FirestoreProvider';

const shadow = 0.2;

export default function TematickeProgramy({ choose = false }) {
    const { data } = useFirestore();
    const programy = data?.programs_list || [];

    return (
        <Box>
            <Centered>
                <EditableTypography fireKey={choose ? 'program_choose' : 'programs'} sx={{
                    mt: '0px', ...titleStyle, textAlign: 'center', /*color: 'white', textShadow: `
      1px 1px 2px rgba(0,0,0,${shadow}),
      -1px -1px 2px rgba(0,0,0,${shadow}),
      1px -1px 2px rgba(0,0,0,${shadow}),
      -1px 1px 2px rgba(0,0,0,${shadow})
    `,*/
                }} />
            </Centered>


            <Container maxWidth={'lg'} sx={{ px: '0px !important', mt: '120px' }}>
                <Grid container columnSpacing={2} rowSpacing={6} columns={24}>
                    {programy.map((p, i) => <Grid item key={"TemaProgram" + i} xs={24} sm={24} md={12} sx={{ display: 'flex', justifyContent: 'center', /*pt: '0px !important'*/ }}>
                        <MotionAppear amount={0.2}>
                            <Holder data={p} choose={choose} index={i} path={`programs_list.${i}`} />
                        </MotionAppear>
                    </Grid>)}
                </Grid>
            </Container>

        </Box>
    )
}
